@if (!config.minimized) {
  <div class="kx-ai-tabs">
    @for (tab of tabs; track tab) {
      @if ((tab.key === 'voice' && showVoiceTab) || (tab.key === 'scan' && showScanTab)) {
        <button
          class="tab-button"
          [class.active]="activeTab === tab.key"
          (click)="selectTab(tab.key)">
          {{ tab.label }}
        </button>
      }
    }
  </div>
}

<!-- ===== VOICE TAB ===== -->
@if (activeTab === 'voice') {
  <div class="_speech-container" [ngClass]="config.isTranscriptionExpanded ? 'show' : 'hide'">
    <div class="d-flex single-btn-container " >
      <button  type="button" class="collapse-toggle mr-2" (click)="toggleTranscription();config.manualMaximized = !config.manualMaximized" [title]="config.isTranscriptionExpanded ? 'Collapse' : 'Expand'">
        <i class="fa" [ngClass]="config.isTranscriptionExpanded ? 'fa-compress' : 'fa-expand'"></i>
      </button>
      @if (config.minimized && !config.manualMaximized) {
        <button  type="button" class="record-button mr-2"
          [ngClass]="{ 'recording': config.isListening, 'disabled': hasPermission === false }"
          [attr.aria-pressed]="config.isListening"
          [disabled]="hasPermission === false"
          (click)="toggleRecording()">
          <i class="fa" [ngClass]="{'fa-microphone-slash': !config.isListening && !isPaused, 'fa-pause': !config.isListening && isPaused, 'fa-microphone': config.isListening}"></i>
        </button>
      }
    </div>
    @if (!config.minimized || config.manualMaximized) {
      <div class="ai-speech-card-container">
        <ng-container *ngTemplateOutlet="voiceContainer"></ng-container>
      </div>
    }
  </div>
}

<!-- ===== VOICE TAB ===== -->

<!-- ===== SCAN TAB ===== -->
@if (activeTab === 'scan') {
  <div class="tab-content">
    <div class="scan-container">
      <ng-template #customComponent></ng-template>
    </div>
    @if (config.loading) {
      <button type="button" class="close-button" disabled>Processing…</button>
      <ng-container *ngTemplateOutlet="progressSteps"></ng-container>
    }
    @if (!config.loading) {
      <button type="button" (click)="processData()" class="close-button">Done</button>
    }
    <div>
      <ng-template #uiEngineComponent></ng-template>
    </div>
  </div>
}
<!-- ===== SCAN TAB ===== -->


<ng-template #voiceContainer>
  <div class="ai-speech-card">
    @if (!config.voiceServiceAvailable) {
      <div class="card-controls-header disabled">
        <div class="status-banner error centered">
          <svg fill="currentColor" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"
            style="margin-right: 8px;">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"></path>
          </svg>
          <span>{{ config.voiceServiceMessage }}</span>
        </div>
      </div>
    }
    <!-- Header -->
    @if (config.voiceServiceAvailable) {
      <div class="card-controls-header"
        [ngClass]="{ 'recording': config.isListening, 'disabled': hasPermission === false }">
        <!-- Center: Record -->
        <button type="button" class="record-button"
          [ngClass]="{ 'recording': config.isListening, 'disabled': hasPermission === false }"
          [attr.aria-pressed]="config.isListening" [disabled]="hasPermission === false" (click)="toggleRecording()">
          <i class="fa" [ngClass]="{'fa-microphone-slash': !config.isListening && !isPaused, 'fa-pause': !config.isListening && isPaused, 'fa-microphone': config.isListening}"></i>
        </button>
        <div class="d-flex">
        <div class="right-controls-group">
          @if (config.loading && !showProgressBarEnabled()) {
            <div class="processing-container">
              <div class="progress-meta">
                <i class="fa fa-spinner fa-spin"></i>
                <span>{{ config.processingStatus }}</span>
              </div>
              <div class="progress-bar-wrapper">
                @if (config.progressKnown) {
                  <div class="progress-bar-fill" [style.width.%]="config.progressPercent"></div>
                } @else {
                  <div class="progress-bar-fill indeterminate"></div>
                }
              </div>
            </div>
          }
          @if (!config.loading && (fullTranscript || recordedBlob || config.isListening)) {
            <button type="button" (click)="processData()" class="btn-sm">
              <i class="fa fa-check"></i> Generate AIScribe
            </button>
          }
          @if(!config.isListening){
            <!-- <div class="status-chip">
              <span class="status-dot" [class.live]="config.isListening"></span>
              <span style="font-size: 15px; color: black; font-weight: 500;">{{ config.isListening ? 'Listening' : 'Idle' }}</span>
              <div class="wave-mini" [ngStyle]="{'--mic-level': micLevel}" [class.active]="micLevel > 0.02">
                @for (b of [1,2,3,4,5]; track b; let i = $index) {
                  <span class="bar" [style.transform]="barTransform(i)"></span>
                }
              </div>
            </div> -->
          }
          
          @if (config.isBackendVoiceAnalysisEnabled && hasBrowserSpeechRecognition) {
            <div class="mode-toggle">
              <label class="toggle-switch">
                <input type="checkbox" id="mode-toggle" class="toggle-switch-checkbox"
                  [disabled]="!config.isBackendVoiceAnalysisEnabled"
                  [(ngModel)]="config.currentVoiceModeIsBackend" (ngModelChange)="onModeToggle($event)" />
                <span class="toggle-switch-slider"></span>
              </label>
              <span [class.text-gray-400]="!config.currentVoiceModeIsBackend" style="font-size: 15px; color: black; font-weight: 500;">AI</span>
            </div>
          }
        </div>
          <div class="transcription-actions">
          <button type="button" class="btn" title="Clear recording" (click)="handleClearTranscription()"
            [disabled]="!recordedBlob && !config.isListening">
            <i class="fa fa-trash-o"></i> Clear
          </button>
        </div>
        </div>
      </div>
    }

    @if (config.loading && showProgressBarEnabled()) {
      <ng-container *ngTemplateOutlet="progressSteps"></ng-container>
    }

    <!-- Collapsible header with inline preview -->
    <div class="collapsible-header" (click)="toggleTranscription('onlyArrowCollaspe')"
      [attr.aria-expanded]="config.isTranscriptionExpanded &&!isTrascriptionCollapsed" aria-controls="transcription-panel">
      <div class="collapsible-title">Voice Recording</div>

      <!-- live one-line preview when collapsed -->
      @if (isTrascriptionCollapsed) {
        <div class="collapsible-summary">
          @if (config.isListening) {
            {{ recordingStatusText }} · {{ formatDuration() }}
          } @else if (audioUrl) {
            Recording ready · {{ formatDuration() }}
          } @else {
            No recording yet
          }
        </div>
      }

      <i class="fa fa-chevron-down chev" [class.rotated]="!isTrascriptionCollapsed"></i>
    </div>

    <!-- Collapsible content -->
    <div id="transcription-panel" class="collapsible-content" [class.expanded]="config.isTranscriptionExpanded">
      <div class="card-body">
        @if (hasPermission === false) {
          <div class="status-banner error">
            <svg fill="currentColor" viewBox="0 0 20 20" width="14" height="14" aria-hidden="true">
              <path
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z">
              </path>
            </svg>
            <span>Microphone access denied.</span>
          </div>
        }

        <!-- Recording-only stage: no live transcript, just a clear "something is happening" view -->
        <div id="transcription-content" class="recording-stage" aria-live="polite" aria-atomic="false">
          @if (config.isListening) {
            <div class="recording-live">
              <!-- <div class="recording-live-pulse">
                <span class="pulse-ring"></span>
                <i class="fa fa-microphone"></i>
              </div> -->
              <div class="recording-live-timer">{{ formatDuration() }}</div>
              <div class="recording-live-status">{{ recordingStatusText }}</div>
              <div class="wave-big" [ngStyle]="{'--mic-level': micLevel}" [class.active]="micLevel > 0.02">
                @for (b of [1,2,3,4,5,6,7,8]; track b; let i = $index) {
                  <span class="bar" [style.transform]="barTransform(i)"></span>
                }
              </div>
            </div>
          } @else if (audioUrl) {
            <div class="recording-done">
              <div class="recording-ready">
                <i class="fa fa-check-circle"></i>
                <span>Recording ready · {{ formatDuration() }}</span>
              </div>
              <div class="audio-playback">
                <audio [src]="audioUrl" controls preload="auto" class="audio-player"
                  (loadedmetadata)="fixAudioDuration($event)"></audio>
              </div>
            </div>
          } @else {
            <div class="placeholder-text">
              <!-- <i class="fa fa-microphone-slash placeholder-icon"></i> -->
              <span>Tap the mic to start recording your voice</span>
            </div>
          }
        </div>

      
      </div>
    </div>

  </div>
</ng-template>

<!-- Live AI fill progress: steps come from ai_async_tasks progress when available -->
<ng-template #progressSteps>
  <div class="ai-progress-panel" aria-live="polite">
    <div class="ai-progress-head">
      <span>AI is filling the form, please wait…</span>
      @if (config.progressKnown) {
        <span class="ai-progress-percent">{{ config.progressPercent }}%</span>
      }
    </div>
    <div class="progress-bar-wrapper">
      @if (config.progressKnown) {
        <div class="progress-bar-fill" [style.width.%]="config.progressPercent"></div>
      } @else {
        <div class="progress-bar-fill indeterminate"></div>
      }
    </div>
    <ul class="ai-progress-steps">
      @for (step of config.progressSteps; track $index) {
        <li [class]="step.state">
          <i class="fa" [ngClass]="step.state === 'done' ? 'fa-check-circle' : 'fa-spinner fa-spin'"></i>
          <span>{{ step.label }}</span>
        </li>
      }
    </ul>
  </div>
</ng-template>
